@if (isInitialized) {
  <oe-flat-widget button [modalComponent]="modalComponent" [title]="component.alias"
    [icon]="{name: 'trending-down-outline', color: 'normal'}">
    <oe-flat-widget-line
      [name]="('EDGE.INDEX.WIDGETS.PEAKSHAVING.MOST_STRESSED_PHASE' | translate) + '&nbsp;' + (mostStressedPhase | async)?.name"
      [converter]="CONVERT_WATT_TO_KILOWATT" [value]="(mostStressedPhase | async)?.value">
    </oe-flat-widget-line>
    <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.PEAKSHAVING.PEAKSHAVING_POWER'| translate"
    [converter]="CONVERT_WATT_TO_KILOWATT" [value]="peakShavingPower"></oe-flat-widget-line>
    <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.PEAKSHAVING.RECHARGE_POWER' | translate"
      [converter]="CONVERT_WATT_TO_KILOWATT" [value]="rechargePower">
    </oe-flat-widget-line>
  </oe-flat-widget>
}
